import { useState } from "react";
import { t } from "i18next";
import { ROWS_PER_PAGE_OPTIONS, DEFAULT_ROWS_PER_PAGE } from "./TableConfig";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import {
  Box,
  TextField,
  InputAdornment,
  IconButton,
  Tooltip,
  Menu,
  MenuItem,
  Checkbox,
  ListItemText,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import { FaCloudDownloadAlt } from "react-icons/fa";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const SearchWithFilter = ({
  searchText,
  handleSearch,
  columns,
  searchColumns,
  setSearchColumns,
 
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = (e) => setAnchorEl(e.currentTarget);
  const closeMenu = () => setAnchorEl(null);

  const toggleCol = (name) => {
    if (!setSearchColumns) return;
    setSearchColumns((prev) =>
      prev.includes(name) ? prev.filter((n) => n !== name) : [...prev, name]
    );
  };

  const searchableCols = columns.filter((c) => c.options?.search !== false);

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <TextField
        size="small"
        placeholder={t("Search")}
        value={searchText || ""}
        onChange={(e) => handleSearch(e.target.value)}
        variant="standard"
        InputProps={{
          disableUnderline: true,
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <Tooltip title={t("اختيار أعمدة البحث")}>
                <IconButton onClick={openMenu} size="small">
                  <FilterListIcon style={{ color: "#D52953" }} />
                </IconButton>
              </Tooltip>
            </InputAdornment>
          ),
          sx: {
            paddingBlock: "9px 9px",
            paddinginline: "15px 30px",
            backgroundColor: "transparent",
            borderBottom: "1px solid #D52953",
            borderRadius: "8px",
            outline: "none",
            boxShadow: "none",
            px: 1,
          },
        }}
        sx={{
          minWidth: 260,
          backgroundColor: "transparent",
          "& .MuiInputBase-input": {
            backgroundColor: "transparent",
          },
        }}
      />



      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={closeMenu}
        slotProps={{
          paper: {
            sx: { borderRadius: "10px", overflow: "hidden" },
            elevation: 3,
          },
        }}
      >
        {searchableCols.map((c) => (
          <MenuItem key={c.name} onClick={() => toggleCol(c.name)}>

            <Checkbox
              checked={searchColumns.includes(c.name)}
              onChange={() => toggleCol(c.name)}
              icon={<RadioButtonUncheckedIcon />}
              checkedIcon={<CheckCircleIcon />}
              sx={{ color: "#D52953", "&.Mui-checked": { color: "#D52953" } }}
            />
            <ListItemText primary={c.label || c.name} />
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

const createOptions = (title, columns, rawData, extra = {}) => {
  const { searchColumns = [], setSearchColumns } = extra;

  const handleDownload = () => {
    const visibleColumns = columns.filter((col) => col.display !== "false");
    const headers = visibleColumns.map((col) => col.label);
    const columnNames = visibleColumns.map((col) => col.name);

    const sheetData = [
      headers,
      ...rawData.map((row) =>
        columnNames.map((name) => {
          const value = row?.[name] ?? "";
          if (typeof value === "object" && value !== null) {
            if (value.MONTH && value.YEAR) {
              const monthName = new Intl.DateTimeFormat("ar", { month: "long" }).format(
                new Date(value.YEAR, value.MONTH - 1)
              );
              return monthName;
            }
            if (value.YEAR && value.QUARTER) {
              return `${value.YEAR} (${value.QUARTER})`;
            }
          }
          return typeof value === "number" ? value : value;
        })
      ),
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "تقرير");
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `${title}.xlsx`);
  };
  const ToolbarExtras = () => {
    const handleDownload = () => {
      const visibleColumns = columns.filter((col) => col.display !== "false");
      const headers = visibleColumns.map((col) => col.label);
      const columnNames = visibleColumns.map((col) => col.name);

      const sheetData = [
        headers,
        ...rawData.map((row) =>
          columnNames.map((name) => {
            const value = row?.[name] ?? "";
            if (typeof value === "object" && value !== null) {
              if (value.MONTH && value.YEAR) {
                const monthName = new Intl.DateTimeFormat("ar", { month: "long" }).format(
                  new Date(value.YEAR, value.MONTH - 1)
                );
                return monthName;
              }
              if (value.YEAR && value.QUARTER) {
                return `${value.YEAR} (${value.QUARTER})`;
              }
            }
            return typeof value === "number" ? value : value;
          })
        ),
      ];

      const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "تقرير");
      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
      const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
      saveAs(blob, `${title}.xlsx`);
    };

    return (
      <>

        <Tooltip title={t("Download")}>
          <IconButton onClick={handleDownload}>
            <FaCloudDownloadAlt style={{ color: "#D52953" }} />
          </IconButton>
        </Tooltip>

      </>
    );
  };
  return {
    filterType: "checkbox",
    filter: false,
    responsive: "standard",
    print: true,
    download: false,
    selectableRows: "none",
    rowsPerPageOptions: ROWS_PER_PAGE_OPTIONS,
    rowsPerPage: DEFAULT_ROWS_PER_PAGE,
    searchAlwaysOpen: true,
    displayRows: false,

    textLabels: {
      body: {
        noMatch: t("NoData_Page"),
        toolTip: t("Sort"),
        columnHeaderTooltip: (column) => `${t("Sort")} ${column.label}`,
      },
      pagination: {
        next: t("Next"),
        previous: t("Previous"),
        rowsPerPage: t("RowsPerPage"),
      },
      viewColumns: { title: t("ShowColumn") },
    },

    customSearchRender: (searchText, handleSearch) => (
      <SearchWithFilter
        searchText={searchText}
        handleSearch={handleSearch}
        columns={columns}
        searchColumns={searchColumns}
        setSearchColumns={setSearchColumns}
        onDownload={handleDownload}
      />




    ),
    customToolbar: () => <ToolbarExtras />,

    onTableChange: (_action, tableState) => {
      window.lastTableState = {
        columns: tableState.columns,
        displayData: tableState.displayData,
      };
    },
  };
};

export default createOptions;
